// Phase 7-C: 休講情報 API（クラス単位 Schedule / 日付単位 ScheduleAllClosed）
// 設計: membership_kyuko_spec_v5.md 7.3 / 7.4

const apiUrl = process.env.REACT_APP_API_URL;

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    // ignore parse error
  }
  if (!response.ok) {
    const message = (data && data.error) || `HTTP ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.data = data;
    throw err;
  }
  return data;
};

// 年月別の休講情報取得（v5 7.3）
// 戻り値: { "YYYY-MM-DD": { overrides: [...], all_closed_studios?: "all"|[..], all_closed_reason?: {..}, all_closed_ids?: {..} } }
export const fetchScheduleOverrides = async (year, month, studioId) => {
  const params = new URLSearchParams({ year: String(year), month: String(month) });
  if (studioId != null && studioId !== "") params.set("studio_id", String(studioId));
  const res = await fetch(`${apiUrl}/api/get_schedule_overrides/?${params.toString()}`, {
    method: "GET",
    credentials: "include",
  });
  return handleResponse(res);
};

// クラス単位の休講等 upsert（複数件）
// items: [{ placement_id, date, status, substitute_instructor?, reschedule_from_date?, new_start?, new_end?, note? }]
export const upsertScheduleOverrides = async (items) => {
  const res = await fetch(`${apiUrl}/api/upsert_schedule_overrides/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });
  return handleResponse(res);
};

// クラス単位の休講等 論理削除（schedule_id 指定）
export const deleteScheduleOverride = async (scheduleId) => {
  const res = await fetch(`${apiUrl}/api/delete_schedule_override/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ schedule_id: scheduleId }),
  });
  return handleResponse(res);
};

// 全クラス休講 upsert（複数件）
// items: [{ date, studio_id: "all"|number, reason? }]
export const upsertAllClosed = async (items) => {
  const res = await fetch(`${apiUrl}/api/upsert_all_closed/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });
  return handleResponse(res);
};

// 全クラス休講 論理削除（all_closed_id 指定）
export const deleteAllClosed = async (allClosedId) => {
  const res = await fetch(`${apiUrl}/api/delete_all_closed/`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ all_closed_id: allClosedId }),
  });
  return handleResponse(res);
};
